var React = require('react');

function ShieldCheck (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M26 5H6a2 2 0 0 0-2 2v7.35c0 11.2 9.48 14.92 11.38 15.55.4.13.84.13 1.24 0C18.52 29.27 28 25.55 28 14.35V7a2 2 0 0 0-2-2Zm0 9.35c0 9.8-8.3 13.08-10 13.65-1.7-.57-10-3.84-10-13.65V7h20v7.35ZM10.3 17.7a1 1 0 0 1 1.4-1.42l2.3 2.3 6.3-6.3a1 1 0 0 1 1.4 1.42l-7 7a1 1 0 0 1-1.4 0l-3-3Z"}));
}

ShieldCheck.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = ShieldCheck;

ShieldCheck.default = ShieldCheck;
